import Color from '../Color/Color'
import Tooltip from '../Tooltip/Tooltip'
import classes from './ConfigurationTypeButton.module.scss'
import { forwardRef } from 'react'
import type {
  CSSProperties,
  ReactNode
} from 'react'

export interface Props {
  onClick: () => void
  title: number
  configIcon: ReactNode
  label?: string
  isStayFocus?: boolean
}

const displayWrapper: CSSProperties = {
  display: 'flex'
}

const ConfigurationTypeButton = forwardRef((
  {
    onClick,
    title,
    configIcon,
    label,
    isStayFocus
  }: Props,
  ref: any
) => {
  const isFocusClass = isStayFocus
    ? classes.isFocus
    : ''

  const getConfigTypeButtonClass = () => [
    classes.ConfigurationTypeButton,
    isFocusClass
  ].filter(classStyle => classStyle).join(' ')

  const renderButton = (label?: string) =>
    <button
      aria-label={label}
      className={getConfigTypeButtonClass()}
      onClick={onClick}
      ref={ref}
      type='button'
    >
      <Color variant='theme-filter-icon'>
        {configIcon}
      </Color>
      <div className={classes.textWrapper}>
        {title}
      </div>
    </button>

  return label
    ? (
      <div style={displayWrapper}>
        <Tooltip label={label}>
          {renderButton(label)}
        </Tooltip>
      </div>
    )
    : renderButton()
}
)

export default ConfigurationTypeButton
